// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  padding: 0px !important;
  max-height: 90vh;
  overflow-y: auto;
}

.box {
  max-width: 360px;
  width: 100% !important;
  margin: 10px;
  padding: 0px 25px;
  background: #fff;
  background-size: 50%;
  background-position: top center;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
  background-size: cover;
  background-position: center;
  border-radius: 15px 15px 0px 0px;
  margin: 0px auto;
  background-repeat: no-repeat !important;
  background-size: 100% 90%;
  background-position: top center;
}

.container .box {
  width: 100%;
  min-height: 250px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
}

.box-wrap {
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 30px 0px;
  display: flex;
  flex-wrap: wrap;
}

.box:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

.with-icon {
  text-align: left;
  height: 35px !important;
}
.with-icon img {
  margin: 0px !important;
}

.des-box {
  background: #fff;
  position: relative;
  width: 100%;
}
.des-box > div > div mat-card {
  background: #f3f1f1 !important;
  background: #fff !important;
}
.des-box i {
  color: #212427 !important;
}

.des-box:after {
  content: "";
  width: 200%;
  height: 150vh;
  background: #fff;
  border-radius: 0px;
  position: absolute;
  top: 0px;
  z-index: -1;
  left: -50%;
  right: -50%;
}

.des-box:before {
  content: "";
  width: 200%;
  height: 40vh;
  background: #fff;
  border-radius: 100% 100% 0px 0px;
  position: absolute;
  top: -34px;
  z-index: -1;
  left: -50%;
  right: -50%;
}

.title-box {
  padding: 0px 0px 60px 0px;
  width: 100%;
}

.title-div {
  border-bottom: 1px solid gray;
}

.title-box h2 {
  color: #fff !important;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 20px;
  text-align: left;
}

.title-box ul {
  margin: 0px;
  padding: 0px;
}

.title-box ul li {
  color: #fff;
  list-style: none;
  padding: 8px 10px 8px 0px;
  font-size: 16px;
  text-align: left;
}

.title-box ul li span {
  margin-right: 8px;
}

.footer-div {
  border-top: 1px solid gray;
  display: flex;
  justify-content: space-between;
}

.footer-div p {
  margin-top: 10px;
  margin-bottom: 0px;
}

p,
h5 {
  color: #212427 !important;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

h5 {
  font-size: 16px;
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 10px;
}

.close-ico {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #ffffff;
  opacity: 1 !important;
  z-index: 10;
  cursor: pointer;
}

.close-ico .close-icon {
  font-size: 24px;
}

.code-div {
  height: 200px;
  overflow-y: scroll;
}

.input-container {
  position: relative;
  display: flex;
  height: 2.8rem;
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  margin-top: 10px;
  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);
}

.input-container input {
  height: 100%;
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgb(176, 190, 197);
  background-color: transparent;
  padding: 0.625rem 70px 0.625rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  color: rgb(69, 90, 100);
  outline: none;
  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}

.invite-btn {
  position: absolute;
  cursor: pointer;
  right: 4px;
  top: 4px;
  bottom: 4px;
  z-index: 10;
  border-radius: 4px;
  background-color: #5ea1d8;
  color: white;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
  vertical-align: middle;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border: none;
}

.invite-btn:hover {
  right: 2px;
  top: 2px;
  bottom: 2px;
  border-radius: 8px;
}

.input-container input:placeholder-shown ~ .invite-btn {
  pointer-events: none;
  background-color: #5ea1d8;
  opacity: 0.5;
}

form {
  display: flex;
  align-items: center;
}
form input {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  transition: all 0.5s ease-in-out;
  border-radius: 5px;
  outline: none !important;
  border: 0.5px solid lightgrey;
}

.parent-comment-box {
  background: #f3f1f1 !important;
  padding: 10px;
  max-height: 400px;
  overflow-y: scroll;
}

.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {
  background: #f8f8f8 !important;
  margin-left: 40px;
  margin-top: 10px;
}
.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment mat-card {
  padding: 10px;
}

@media (max-width: 767px) {
  p {
    flex-wrap: wrap;
  }
}
.qrcode-heading {
  font-size: 20px !important;
  font-weight: bold !important;
  justify-content: center;
  margin-top: -10px !important;
}

.download-link {
  margin-top: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none !important;
  color: #212427;
}

:host-context(body.theme-dark) .des-box,
:host-context(body.theme-dark) .des-box:before,
:host-context(body.theme-dark) .des-box:after {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .qrcode-heading,
:host-context(body.theme-dark) p,
:host-context(body.theme-dark) h5,
:host-context(body.theme-dark) .download-link,
:host-context(body.theme-dark) .close-ico,
:host-context(body.theme-dark) .close-ico .close-icon,
:host-context(body.theme-dark) .des-box i {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .input-container {
  background-color: #1f2937 !important;
}
:host-context(body.theme-dark) .input-container input,
:host-context(body.theme-dark) form input {
  background-color: #1f2937 !important;
  color: #f8fafc !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
}
:host-context(body.theme-dark) .parent-comment-box,
:host-context(body.theme-dark) .des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {
  background: #0f172a !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-profile-qr-code/user-profile-qr-code.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AACA;EACE,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,+BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8EAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;EACA,gCAAA;EACA,gBAAA;EACA,uCAAA;EACA,yBAAA;EACA,+BAAA;AAEF;;AACA;EACE,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,kBAAA;AAEF;;AACA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;AAEF;;AAAA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,8BAAA;AAGF;;AADA;EACE,gBAAA;EACA,uBAAA;AAIF;AAHE;EACE,sBAAA;AAKJ;;AADA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;AAIF;AADM;EACE,8BAAA;EACA,2BAAA;AAGR;AACE;EACE,yBAAA;AACJ;;AAEA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AACF;;AACA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAEF;;AACA;EACE,yBAAA;EACA,WAAA;AAEF;;AAAA;EACE,6BAAA;AAGF;;AADA;EACE,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAIF;;AAFA;EACE,WAAA;EACA,YAAA;AAKF;;AAHA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAMF;;AAJA;EACE,iBAAA;AAOF;;AAJA;EACE,0BAAA;EACA,aAAA;EACA,8BAAA;AAOF;;AALA;EACE,gBAAA;EACA,kBAAA;AAQF;;AALA;;EAEE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAQF;;AANA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AASF;;AAPA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;AAUF;;AARA;EACE,eAAA;AAWF;;AARA;EACE,aAAA;EACA,kBAAA;AAWF;;AARA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AAWF;;AARA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,6BAAA;EACA,uCAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,kDAAA;AAWF;;AARA;EACE,kBAAA;EACA,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AAWF;;AARA;EACE,UAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AAWF;;AARA;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;AAWF;;AATA;EACE,aAAA;EACA,mBAAA;AAYF;AAXE;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,6BAAA;AAaJ;;AAVA;EACE,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AAaF;;AAXA;EACE,8BAAA;EACA,iBAAA;EACA,gBAAA;AAcF;AAbE;EACE,aAAA;AAeJ;;AAZA;EACE;IACE,eAAA;EAeF;AACF;AAZA;EACE,0BAAA;EACA,4BAAA;EACA,uBAAA;EACA,4BAAA;AAcF;;AAXA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,cAAA;AAcF;;AAVE;;;EAGE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAaJ;AAVE;;;;;;;EAOE,yBAAA;AAYJ;AATE;EACE,oCAAA;AAWJ;AARE;;EAEE,oCAAA;EACA,yBAAA;EACA,kDAAA;AAUJ;AAPE;;EAEE,8BAAA;AASJ","sourcesContent":[".container {\n  padding: 0px !important;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n.box {\n  max-width: 360px;\n  width: 100% !important;\n  margin: 10px;\n  padding: 0px 25px;\n  background: #fff;\n  background-size: 50%;\n  background-position: top center;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 5px 11px 0 rgb(0 0 0 / 18%), 0 4px 15px 0 rgb(0 0 0 / 15%);\n  overflow: hidden;\n  background-size: cover;\n  background-position: center;\n  border-radius: 15px 15px 0px 0px;\n  margin: 0px auto;\n  background-repeat: no-repeat !important;\n  background-size: 100% 90%;\n  background-position: top center;\n}\n\n.container .box {\n  width: 100%;\n  min-height: 250px;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  border-radius: 8px;\n}\n\n.box-wrap {\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  padding: 30px 0px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.box:after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.5);\n}\n.with-icon {\n  text-align: left;\n  height: 35px !important;\n  img {\n    margin: 0px !important;\n  }\n}\n\n.des-box {\n  background: #fff;\n  position: relative;\n  width: 100%;\n  & > div {\n    & > div {\n      mat-card {\n        background: #f3f1f1 !important;\n        background: #fff !important;\n      }\n    }\n  }\n  i {\n    color: #212427 !important;\n  }\n}\n.des-box:after {\n  content: \"\";\n  width: 200%;\n  height: 150vh;\n  background: #fff;\n  border-radius: 0px;\n  position: absolute;\n  top: 0px;\n  z-index: -1;\n  left: -50%;\n  right: -50%;\n}\n.des-box:before {\n  content: \"\";\n  width: 200%;\n  height: 40vh;\n  background: #fff;\n  border-radius: 100% 100% 0px 0px;\n  position: absolute;\n  top: -34px;\n  z-index: -1;\n  left: -50%;\n  right: -50%;\n}\n\n.title-box {\n  padding: 0px 0px 60px 0px;\n  width: 100%;\n}\n.title-div {\n  border-bottom: 1px solid gray;\n}\n.title-box h2 {\n  color: #fff !important;\n  font-size: 18px;\n  font-weight: normal;\n  margin-bottom: 20px;\n  text-align: left;\n}\n.title-box ul {\n  margin: 0px;\n  padding: 0px;\n}\n.title-box ul li {\n  color: #fff;\n  list-style: none;\n  padding: 8px 10px 8px 0px;\n  font-size: 16px;\n  text-align: left;\n}\n.title-box ul li span {\n  margin-right: 8px;\n}\n\n.footer-div {\n  border-top: 1px solid gray;\n  display: flex;\n  justify-content: space-between;\n}\n.footer-div p {\n  margin-top: 10px;\n  margin-bottom: 0px;\n}\n\np,\nh5 {\n  color: #212427 !important;\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\nh5 {\n  font-size: 16px;\n  font-weight: bold;\n  margin-top: 0px;\n  margin-bottom: 10px;\n}\n.close-ico {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  color: #ffffff;\n  opacity: 1 !important;\n  z-index: 10;\n  cursor: pointer;\n}\n.close-ico .close-icon {\n  font-size: 24px;\n}\n\n.code-div {\n  height: 200px;\n  overflow-y: scroll;\n}\n\n.input-container {\n  position: relative;\n  display: flex;\n  height: 2.8rem;\n  width: 100%;\n  background-color: #fff;\n  border-radius: 8px;\n  margin-top: 10px;\n  box-shadow: 20px 20px 30px rgba(0, 0, 0, 0.05);\n}\n\n.input-container input {\n  height: 100%;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid rgb(176 190 197);\n  background-color: transparent;\n  padding: 0.625rem 70px 0.625rem 0.75rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n  color: rgb(69 90 100);\n  outline: none;\n  transition: all 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.invite-btn {\n  position: absolute;\n  cursor: pointer;\n  right: 4px;\n  top: 4px;\n  bottom: 4px;\n  z-index: 10;\n  border-radius: 4px;\n  background-color: #5ea1d8;\n  color: white;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  text-align: center;\n  vertical-align: middle;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  border: none;\n}\n\n.invite-btn:hover {\n  right: 2px;\n  top: 2px;\n  bottom: 2px;\n  border-radius: 8px;\n}\n\n.input-container input:placeholder-shown ~ .invite-btn {\n  pointer-events: none;\n  background-color: #5ea1d8;\n  opacity: 0.5;\n}\nform {\n  display: flex;\n  align-items: center;\n  input {\n    background-color: #f6f6f6;\n    border: none;\n    color: #0d0d0d;\n    padding: 15px 32px;\n    text-align: center;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 16px;\n    margin: 5px;\n    width: 85%;\n    border: 2px solid #f6f6f6;\n    transition: all 0.5s ease-in-out;\n    border-radius: 5px;\n    outline: none !important;\n    border: 0.5px solid lightgrey;\n  }\n}\n.parent-comment-box {\n  background: #f3f1f1 !important;\n  padding: 10px;\n  max-height: 400px;\n  overflow-y: scroll;\n}\n.des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {\n  background: #f8f8f8 !important;\n  margin-left: 40px;\n  margin-top: 10px;\n  mat-card {\n    padding: 10px;\n  }\n}\n@media (max-width: 767px) {\n  p {\n    flex-wrap: wrap;\n  }\n}\n\n.qrcode-heading {\n  font-size: 20px !important;\n  font-weight: bold !important;\n  justify-content: center;\n  margin-top: -10px !important;\n}\n\n.download-link {\n  margin-top: 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none !important;\n  color: #212427;\n}\n\n:host-context(body.theme-dark) {\n  .des-box,\n  .des-box:before,\n  .des-box:after {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .qrcode-heading,\n  p,\n  h5,\n  .download-link,\n  .close-ico,\n  .close-ico .close-icon,\n  .des-box i {\n    color: #e2e8f0 !important;\n  }\n\n  .input-container {\n    background-color: #1f2937 !important;\n  }\n\n  .input-container input,\n  form input {\n    background-color: #1f2937 !important;\n    color: #f8fafc !important;\n    border-color: rgba(148, 163, 184, 0.45) !important;\n  }\n\n  .parent-comment-box,\n  .des-box > div > div mat-card.mat-mdc-card.mdc-card.example-card.child-comment {\n    background: #0f172a !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
